
import VideoList from "../views/lsjMediaLibrary/videoList";
import ComicsList from "../views/lsjMediaLibrary/comicsList";
import PostList from "../views/lsjMediaLibrary/postList";
import NovelList from "../views/lsjMediaLibrary/novelList";
import Main from "../views/main";

const lsjMediaLibRouter = {
  path: '/lsjMediaLibrary',
  component: Main,
  redirect: '/lsjMediaLibraryVideoList',
  name: 'LsjMediaLibrary',
  title: '老司机媒资库管理',
  icon: 'el-icon-film',
  children: [
    {
      path: '/lsjMediaLibraryVideoList',
      name: 'LsjMediaLibraryVideoList',
      title: '影片列表',
      component: VideoList,
      meta: { title: "老司机影片列表", keepAlive: true },
    },
    {
      path: '/lsjMediaLibraryPostList',
      name: 'LsjMediaLibraryPostList',
      title: '帖子列表',
      component: PostList,
      meta: { title: "老司机帖子列表", keepAlive: true },

    },
    {
      path: '/lsjMediaLibraryComicsList',
      name: 'LsjMediaLibraryComicsList',
      title: '漫画列表',
      component: ComicsList,
      meta: { title: "老司机漫画列表", keepAlive: true },

    },
    {
      path: '/lsjMediaLibraryNovelList',
      name: 'LsjMediaLibraryNovelList',
      title: '小说列表',
      component: NovelList,
      meta: { title: "老司机小说列表", keepAlive: true },
    }
  ]
}
export default lsjMediaLibRouter;